export default __webpack_public_path__ + "static/media/logo_IAS.e0b72d6b.png";